export default __webpack_public_path__ + "static/SehEunH-aa66607f76575db0331bbfa9f260a0a9.png";